import { Link } from "react-router-dom";
import { site } from "@/mocks/hotlist";

const COLUMNS = [
  {
    title: "热门榜单",
    links: [
      { label: "实时热度总榜", href: "#hot" },
      { label: "热议榜", href: "#ranking" },
      { label: "爆款排行", href: "#ranking" },
      { label: "围观涨粉榜", href: "#fans" },
    ],
  },
  {
    title: "内容专题",
    links: [
      { label: "话题分类", href: "#topics" },
      { label: "热门复盘", href: "#deepdive" },
      { label: "常见问题", href: "#faq" },
      { label: "关于本站", href: "#about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-fill text-background-50 text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                {site.brand}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-sm">
              {site.slogan}，实时汇总热度榜、热议榜、爆款排行与围观涨粉榜，帮你用最少的时间看清当下最受关注的瓜。
            </p>
            <p className="mt-4 text-xs text-foreground-500">{site.updatedAt}</p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
                <a href="#hot" className="hover:text-primary-400 transition-colors cursor-pointer">
                  {col.title}
                </a>
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
              <a href="#contact" className="hover:text-primary-400 transition-colors cursor-pointer">
                联系与投稿
              </a>
            </h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="w-7 h-7 rounded-md bg-background-200/70 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-primary-400 text-sm" />
                </span>
                {site.email}
              </li>
              <li className="flex items-center gap-2">
                <span className="w-7 h-7 rounded-md bg-background-200/70 flex items-center justify-center shrink-0">
                  <i className="ri-wechat-line text-secondary-400 text-sm" />
                </span>
                微信：{site.wechat}
              </li>
            </ul>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary-400 whitespace-nowrap cursor-pointer hover:text-primary-300 transition-colors"
            >
              提交话题线索
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © 2026 {site.brand} · 站内话题均以公开讨论为基础整理，涉及人物统一使用代称。
          </p>
          <nav className="flex items-center gap-4" aria-label="页脚导航">
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
              首页
            </Link>
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
              关于我们
            </a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
              常见问题
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}